import { ComponentProps } from 'react'

import { StatusBadge as StatusBadgeBase } from '@domain-group/suit-theme'

import useStatus from '@hooks/useStatus'

interface StatusBadgeProps extends ComponentProps<typeof StatusBadgeBase> {
  options?: {
    defaultStatusKey?: string,
  },
  statusId: number,
}

const StatusBadge = (props: StatusBadgeProps) => {
  const { options, statusId, ...restProps } = props

  const statusPayload = useStatus({ id: statusId }, options)
  const {
    color,
    // @ts-expect-error TS2339
    status: { title },
  } = statusPayload

  return (
    <StatusBadgeBase color={color} text={title} {...restProps} />
  )
}

export default StatusBadge
